module.exports = __webpack_public_path__ + "fonts/EuclidEnercity-Light-WebS.0e9151a4.woff2";